import React from 'react';
import { shape } from 'prop-types';

import styles from './Image.module.scss';

const Image = ({ content }) => (
  <div className={styles.wrapper}>
    {content.imageLinkUrl ? (
      <a href={`${window.location.origin}${content.imageLinkUrl}`}>
        <img
          className={styles.image}
          src={content.imageUrl}
          alt={content.imageDescription}
        />
      </a>
    ) : (
      <img
        className={styles.image}
        src={content.imageUrl}
        alt={content.imageDescription}
      />
    )}
    <p className={styles.imageDescription}>{content.imageDescription}</p>
  </div>
);

Image.propTypes = {
  content: shape(),
};

Image.defaultProps = {
  content: null,
};

export default Image;
